<mat-form-field class="searchInput">
  <label for="si" class="sr-only">search input</label>
  <input id="si" matInput #input [placeholder]="placeHolder" title="placeHolder" [formControl]="searchCtrl"
     />
  <button type="button" *ngIf="searchCtrl.value!==''" matSuffix aria-label="Clear"
    (click)="clearSearch()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>

